import { PieWidget, MapDatasetEnriched, CategoryWidget } from 'features/builder/types'
import {
  categoryWidgetAvailableOperations,
  isCategoryWidgetValid,
  isWidgetCategoryAvailable,
  validateCategoryWidget
} from './categoryWidget'
import { AggregationType } from '@carto/api-client'

//
// actually Pie _as_ for now has exactly same logic as CategoryWidget
// > just re-export from categoryWidget.ts with different names
//

export function isPieWidgetValid(widget: PieWidget, { source }: { source: MapDatasetEnriched }): boolean {
  return isCategoryWidgetValid(widget as unknown as CategoryWidget, { source })
}

export function validatePieWidget(widget: PieWidget, { source }: { source: MapDatasetEnriched }) {
  return validateCategoryWidget(widget as unknown as CategoryWidget, { source }) as unknown as PieWidget
}

export function pieWidgetAvailableOperations(source: MapDatasetEnriched): AggregationType[] {
  return categoryWidgetAvailableOperations(source)
}

export function isWidgetPieAvailable(source: MapDatasetEnriched): boolean {
  return isWidgetCategoryAvailable(source)
}
